import StocktakeItemsBoxListPanel from "./stocktakeItemsBoxListPanel.container";
export default StocktakeItemsBoxListPanel;
